import { LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE } from "./logout-cooldown-limit.action";

export const LOGOUT_COOLDOWN_LIMIT_MESSAGE_CONTEXT = {
	get: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.get,
	update: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.update,
	delete: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.delete,
};

export const LOGOUT_COOLDOWN_LIMIT_MESSAGE_CODE = {
	getError: "M_LOGOUT_COOLDOWN_LIMIT_GET_ERROR",
	updateSuccess: "M_LOGOUT_COOLDOWN_LIMIT_UPDATE_SUCCESS",
	updateError: "M_LOGOUT_COOLDOWN_LIMIT_UPDATE_ERROR",
	deleteSuccess: "M_LOGOUT_COOLDOWN_LIMIT_DELETE_SUCCESS",
	deleteError: "M_LOGOUT_COOLDOWN_LIMIT_DELETE_ERROR",
};
